import styled from "@emotion/styled";
import { Box, Theme } from "@mui/material";

export const FiltersContainer = styled(Box)<{theme: Theme}>((props) => ({
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gridGap: props.theme.spacing(2),
    marginTop: props.theme.spacing(3),
}));

export const TotalsCardsContainer = styled(Box)<{theme: Theme}>((props) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridGap: props.theme.spacing(2),
    margin: props.theme.spacing(3),
}));

export const InfoContainer = styled(Box)<{theme: Theme}>((props) => ({
    display: "grid",
    gridTemplateColumns: "4fr 1fr",
    gridGap: props.theme.spacing(2),
    margin: props.theme.spacing(3),
}));